import TextFieldComponent from './text-field-component';

/***
 * a simple text-entry field.
 */
const textField = angular
    .module('FacilityData.ClientEdit.FormFields.TextField', [])
    .component('textField', TextFieldComponent)
    .name;

export default textField;


// WEBPACK FOOTER //
// ./app/common/form-fields/text-field/text-field.js